import React, { Component } from 'react';
import { Link } from 'react-router-dom';


export default class Valueprop extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            page: "travelers",
            step: 1
        };

        this.setPage = this.setPage.bind(this);
        this.setStep = this.setStep.bind(this);
    }

    componentDidMount() {
    }


    componentWillUnmount() {
    }


    setPage(page) {
        this.setState({
            page: page,
            step: 1
        });
    }


    setStep(step) {
        this.setState({
            step: step
        });
    }


    render() {

        return (
            <div className="home__howitworks-container">
                <h2 className="home__howitworks__title text-title">
                    How it works
                </h2>
                <div className="home__howitworks-wrapper">
                    <div className="home__howitworks__buttonbox">
                        <div
                            onClick={() => this.setPage("travelers")}
                            className={
                                "button home__howitworks__buttonbox__button" +
                                (this.state.page === "travelers" ? " home__howitworks__buttonbox__button--active" : "")
                            }
                        >
                            <div className="home__howitworks__buttonbox__button__picture">
                                <img
                                    src={"https://guidr-media-dev.s3.us-east-1.amazonaws.com/static-files/howitworks/traveler.webp"}
                                    alt={"For travelers"}
                                    className={"home__howitworks__buttonbox__button__picture-inner"}
                                />
                            </div>
                            <div className="home__howitworks__buttonbox__button__label text-subtitle">
                                For travelers
                            </div>
                        </div>
                        <div
                            onClick={() => this.setPage("creators")}
                            className={
                                "button home__howitworks__buttonbox__button" +
                                (this.state.page === "creators" ? " home__howitworks__buttonbox__button--active" : "")
                            }
                        >
                            <div className="home__howitworks__buttonbox__button__picture">
                                <img
                                    src={"https://guidr-media-dev.s3.us-east-1.amazonaws.com/static-files/howitworks/creator.webp"}
                                    alt={"For travelers"}
                                    className={"home__howitworks__buttonbox__button__picture-inner"}
                                />
                            </div>
                            <div className="home__howitworks__buttonbox__button__label text-subtitle">
                                For travel creators
                            </div>
                        </div>
                        <div
                            onClick={() => this.setPage("hosts")}
                            className={
                                "button home__howitworks__buttonbox__button" +
                                (this.state.page === "hosts" ? " home__howitworks__buttonbox__button--active" : "")
                            }
                        >
                            <div className="home__howitworks__buttonbox__button__picture">
                                <img
                                    src={"https://guidr-media-dev.s3.us-east-1.amazonaws.com/static-files/howitworks/hosts.webp"}
                                    alt={"For travelers"}
                                    className={"home__howitworks__buttonbox__button__picture-inner"}
                                />
                            </div>
                            <div className="home__howitworks__buttonbox__button__label text-subtitle">
                                For hotels & rentals
                            </div>
                        </div>
                        <div
                            onClick={() => this.setPage("tourismagencies")}
                            className={
                                "button home__howitworks__buttonbox__button" +
                                (this.state.page === "tourismagencies" ? " home__howitworks__buttonbox__button--active" : "")
                            }
                        >
                            <div className="home__howitworks__buttonbox__button__picture">
                                <img
                                    src={"https://guidr-media-dev.s3.us-east-1.amazonaws.com/static-files/howitworks/agency.webp"}
                                    alt={"For travelers"}
                                    className={"home__howitworks__buttonbox__button__picture-inner"}
                                />
                            </div>
                            <div className="home__howitworks__buttonbox__button__label text-subtitle">
                                For tourism agencies
                            </div>
                        </div>
                    </div>

                    {/* Travelers */}
                    {this.state.page === "travelers" && (
                        <div className="home__howitworks__stepbox">
                            {[
                                "1. Explore trips",
                                "2. Choose itineraries",
                                "3. Get instant access",
                            ].map((label, idx) => (
                                <div
                                    key={idx}
                                    onClick={() => this.setStep(idx + 1)}
                                    className={
                                        `home__howitworks__stepbox__step home__howitworks__stepbox__step-${idx + 1}` +
                                        (this.state.step === idx + 1
                                            ? " home__howitworks__stepbox__step--active"
                                            : "")
                                    }
                                >
                                    {label}
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Creators */}
                    {this.state.page === "creators" && (
                        <div className="home__howitworks__stepbox">
                            {[
                                "1. Create & share",
                                "2. Market itineraries",
                                "3. Earn & engage",
                            ].map((label, idx) => (
                                <div
                                    key={idx}
                                    onClick={() => this.setStep(idx + 1)}
                                    className={
                                        `home__howitworks__stepbox__step home__howitworks__stepbox__step-${idx + 1}` +
                                        (this.state.step === idx + 1
                                            ? " home__howitworks__stepbox__step--active"
                                            : "")
                                    }
                                >
                                    {label}
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Hosts */}
                    {this.state.page === "hosts" && (
                        <div className="home__howitworks__stepbox">
                            {[
                                "1. Curate itineraries",
                                "2. Share with guests",
                                "3. Delight & upsell",
                            ].map((label, idx) => (
                                <div
                                    key={idx}
                                    onClick={() => this.setStep(idx + 1)}
                                    className={
                                        `home__howitworks__stepbox__step home__howitworks__stepbox__step-${idx + 1}` +
                                        (this.state.step === idx + 1
                                            ? " home__howitworks__stepbox__step--active"
                                            : "")
                                    }
                                >
                                    {label}
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Agencies */}
                    {this.state.page == "tourismagencies" && (
                        <div className="home__howitworks__stepbox">
                            {[
                                "1. Publish trips",
                                "2. Partner promotion",
                                "3. Boost tourism",
                            ].map((label, idx) => (
                                <div
                                    key={idx}
                                    onClick={() => this.setStep(idx + 1)}
                                    className={
                                        `home__howitworks__stepbox__step home__howitworks__stepbox__step-${idx + 1}` +
                                        (this.state.step === idx + 1
                                            ? " home__howitworks__stepbox__step--active"
                                            : "")
                                    }
                                >
                                    {label}
                                </div>
                            ))}
                        </div>
                    )}

                    <div className="home__howitworks__content">

                        {/* Travelers */}
                        {this.state.page == "travelers" && this.state.step == 1 &&
                            <div className="home__howitworks__content__textbox">
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">🗺️ Browse itineraries</span> by destination, season, interests, or budget and use filters to refine your search.
                                </p>
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">🌍 Explore trending destinations</span> and travel experts.
                                </p>
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">👥 See what other itineraries</span> your favorite travel experts have to offer.
                                </p>
                            </div>
                        }

                        {this.state.page == "travelers" && this.state.step == 2 &&
                            <div className="home__howitworks__content__textbox">
                                <p className="home__howitworks__content__textbox__bullet">
                                    {/* <span className="text-bold">🆓 Access free itineraries</span> instantly or purchase exclusive, expert-crafted itineraries for detailed insights. */}
                                    <span className="text-bold">🆓 Access free itineraries</span> instantly with expert-crafted, detailed insights.
                                </p>
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">🔗 Connect with travel experts</span> on different platforms to see if they match your vibe.
                                </p>
                            </div>
                        }

                        {this.state.page == "travelers" && this.state.step == 3 &&
                            <div className="home__howitworks__content__textbox">
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">🗂️ View your ready-to-go itinerary</span> online with maps, tips, and recommendations.
                                </p>
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">💬 Connect with travel experts</span> to clarify your questions or fine-tune your itinerary.
                                </p>
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">🛤️ Follow step-by-step guidance</span> for a seamless travel experience.
                                </p>
                            </div>
                        }

                        {/* Creators */}
                        {this.state.page == "creators" && this.state.step == 1 &&
                            <div className="home__howitworks__content__textbox">
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">✍️ Build detailed itineraries</span> with activities, locations, and recommendations.
                                </p>
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">💡 Add tips, hidden gems</span>, and personal insights.
                                </p>
                                <p className="home__howitworks__content__textbox__bullet">
                                    {/* <span className="text-bold">💰 Set a price</span> or offer itineraries for free to your community. */}
                                    <span className="text-bold">💬 Offer itineraries</span> to your community.
                                </p>
                            </div>
                        }

                        {this.state.page == "creators" && this.state.step == 2 &&
                            <div className="home__howitworks__content__textbox">
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">📢 Market your itineraries</span> to your community through social media.
                                </p>
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">🔗 Redirect your community</span> to your Guidr trip page.
                                </p>
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">🚀 Gain additional exposure</span> to travelers looking for itineraries on Guidr.
                                </p>
                            </div>
                        }

                        {this.state.page == "creators" && this.state.step == 3 &&
                            <div className="home__howitworks__content__textbox">
                                {/* <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">💵 Get paid</span> when travelers purchase your itinerary.
                                </p> */}
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">🤝 Interact with travelers</span> through Q&A or personalized tips.
                                </p>
                                <p className="home__howitworks__content__textbox__bullet">
                                    <span className="text-bold">📈 Continue to grow your community</span> across platforms while managing your itineraries with Guidr.
                                </p>
                            </div>
                        }


                        {/* Hosts */}
                        {this.state.page == "hosts" && (
                            <>
                                {this.state.step == 1 && (
                                    <div className="home__howitworks__content__textbox">
                                        <p className="home__howitworks__content__textbox__bullet">
                                            <span className="text-bold">🏨 Curate local itineraries</span> highlighting nearby attractions, dining, and hidden gems.
                                        </p>
                                        <p className="home__howitworks__content__textbox__bullet">
                                            <span className="text-bold">✍️ Tailor experiences</span> for families, couples, adventurers, and more.
                                        </p>
                                    </div>
                                )}

                                {this.state.step == 2 && (
                                    <div className="home__howitworks__content__textbox">
                                        <p className="home__howitworks__content__textbox__bullet">
                                            <span className="text-bold">🔗 Share itineraries with guests</span> via links or QR codes in booking confirmations, room tablets, or lobby signage.
                                        </p>
                                        <p className="home__howitworks__content__textbox__bullet">
                                            <span className="text-bold">📧 Impress pre‑arrival</span> by sending personalized plans before check‑in.
                                        </p>
                                    </div>
                                )}

                                {this.state.step == 3 && (
                                    <div className="home__howitworks__content__textbox">
                                        <p className="home__howitworks__content__textbox__bullet">
                                            <span className="text-bold">🤩 Delight guests & earn reviews</span> through memorable, seamless stays.
                                        </p>
                                        <p className="home__howitworks__content__textbox__bullet">
                                            <span className="text-bold">💰 Upsell tours & experiences</span> and track incremental revenue.
                                        </p>
                                    </div>
                                )}
                            </>
                        )}


                        {/* Agencies */}
                        {this.state.page == "tourismagencies" && (
                            <>
                                {this.state.step == 1 && (
                                    <div className="home__howitworks__content__textbox">
                                        <p className="home__howitworks__content__textbox__bullet">
                                            <span className="text-bold">🌄 Showcase your region</span> with ready-made itineraries focused on seasons, events, and must-see highlights.
                                        </p>
                                        <p className="home__howitworks__content__textbox__bullet">
                                            <span className="text-bold">🤝 Collaborate with local businesses</span> to feature tours, dining, and attractions that boost the whole community.
                                        </p>
                                    </div>
                                )}

                                {this.state.step == 2 && (
                                    <div className="home__howitworks__content__textbox">
                                        <p className="home__howitworks__content__textbox__bullet">
                                            <span className="text-bold">📲 Distribute itineraries effortlessly</span> via your website, QR codes at visitor centers, and partner hotel welcome emails.
                                        </p>
                                        <p className="home__howitworks__content__textbox__bullet">
                                            <span className="text-bold">🔗 Drive traffic to Guidr pages</span> for deeper content and real-time updates.
                                        </p>
                                    </div>
                                )}

                                {this.state.step == 3 && (
                                    <div className="home__howitworks__content__textbox">
                                        <p className="home__howitworks__content__textbox__bullet">
                                            <span className="text-bold">📈 Attract and retain visitors</span> with compelling plans that encourage longer stays and higher local spend.
                                        </p>
                                        <p className="home__howitworks__content__textbox__bullet">
                                            <span className="text-bold">🗂️ Measure impact & refine</span> by tracking itinerary views and feedback to optimize future campaigns.
                                        </p>
                                    </div>
                                )}
                            </>
                        )}



                        {/* <div className="home__howitworks__content__video">
                            Video
                        </div> */}
                    </div>

                    <div className="home__howitworks__cta-container">
                        {this.state.page == "travelers" &&
                            <Link to={"/travelers"} className="button button-large button-secondary">
                                Learn more
                            </Link>
                        }
                        {this.state.page == "creators" &&
                            <Link to={"/creators"} className="button button-large button-secondary">
                                Learn more
                            </Link>
                        }
                        {this.state.page == "hosts" &&
                            <Link to={"/hosts"} className="button button-large button-secondary">
                                Learn more
                            </Link>
                        }
                        {this.state.page == "tourismagencies" &&
                            <Link to={"/tourismagencies"} className="button button-large button-secondary">
                                Learn more
                            </Link>
                        }
                    </div>

                </div>
            </div>
        )
    }
}
